import { useIntl } from 'react-intl';
import { Button } from './ui/button.tsx';

export function accountLabel(name: string | null, fallback: string): string {
  return name?.trim() ? name : fallback;
}

export function AccountControls({
  errorMessage,
  isActing,
  name,
  onAddPasskey,
  onConnectPasskey,
  onSignOut,
}: {
  errorMessage: string | null;
  isActing: boolean;
  name: string | null;
  onAddPasskey: () => void;
  onConnectPasskey?: () => void;
  onSignOut: () => void;
}) {
  const intl = useIntl();
  const label = accountLabel(
    name,
    intl.formatMessage({ id: 'web.auth.account' }),
  );
  return (
    <section className="grid min-w-0 gap-2 border-t border-border pt-4 pe-4 ps-[var(--chrome-inset)]">
      <span className="overflow-wrap-anywhere text-sm text-muted-foreground">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {onConnectPasskey ? (
          <Button
            className="min-h-10 px-3 text-sm"
            disabled={isActing}
            onClick={onConnectPasskey}
            type="button"
            variant="secondary"
          >
            {intl.formatMessage({ id: 'web.auth.connectPasskey' })}
          </Button>
        ) : null}
        <Button
          className="min-h-10 px-3 text-sm"
          disabled={isActing}
          onClick={onAddPasskey}
          type="button"
          variant="secondary"
        >
          {intl.formatMessage({ id: 'web.auth.addPasskey' })}
        </Button>
        <Button
          className="min-h-10 px-3 text-sm"
          variant="destructive"
          disabled={isActing}
          onClick={onSignOut}
          type="button"
        >
          {intl.formatMessage({ id: 'web.auth.signOut' })}
        </Button>
      </div>
      {isActing ? (
        <span className="text-xs text-muted-foreground">
          {intl.formatMessage({ id: 'web.auth.waiting' })}
        </span>
      ) : null}
      {errorMessage ? (
        <span className="text-xs text-destructive">{errorMessage}</span>
      ) : null}
    </section>
  );
}
